<!--footer start-->
<footer class="saas1 footer2">
    <div class="container">
        <div class="row">
            <!-- Unternehmen -->
            <div class="col-md-3">
                <div class="logo-sec">
                    <div class="footer-title mobile-title">
                        <h3 class="text-white">Über uns</h3>
                    </div>
                    <div class="footer-contant">
                        <img src="../../../../assets/images/Own/Palladio_h_40.png" alt="" class="img-fluid footer-logo">
                        <div class="footer-para">
                            <h6 class="text-white para-address">Obrecht Studios</h6>
                            <h6 class="text-white para-address">Karlsruhe 76137.</h6>
                        </div>
                        <ul class="d-d-flex footer-social social">
                            <li class="footer-social-list">
                                <a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                            </li>
                            <li class="footer-social-list">
                                <a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                            </li>
                            <li class="footer-social-list">
                                <a href="#"><i class="fa fa-google" aria-hidden="true"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Produkte & Funktionen -->
            <div class="col-md-3">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">Produkte & Funktionen</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">Produkte & Funktionen</h5>
                    <ul class="footer-lists">
                        <li><a [routerLink]="['/liste-konfigurieren']">Liste konfigurieren</a></li>
                        <li><a [routerLink]="['/branchen-uebersicht']">Branchen-Übersicht</a></li>
                        <li><a [routerLink]="['/features']">Alle Features</a></li>
                        <li><a [routerLink]="['/faq']">FAQ</a></li>
                    </ul>
                </div>
            </div>

            <!-- Konto -->
            <div class="col-md-3">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">Konto</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">Konto</h5>
                    <ul class="footer-lists">
                        <li><a [routerLink]="['/anmelden']">Anmelden</a></li>
                        <li><a [routerLink]="['/registrieren']">Registrieren</a></li>
                        <li><a [routerLink]="['/profil']">Profil</a></li>
                    </ul>
                </div>
            </div>

            <!-- Rechtliches & Support -->
            <div class="col-md-3">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">Rechtliches & Support</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">Rechtliches & Support</h5>
                    <ul class="footer-lists">
                        <li><a [routerLink]="['/warum-palladio']">Warum Palladio?</a></li>
                        <li><a [routerLink]="['/services']">Über uns</a></li>
                        <li><a [routerLink]="['/kontakt']">Kontakt</a></li>
                        <li><a [routerLink]="['/impressum']">Impressum</a></li>
                        <li><a [routerLink]="['/allgemeine-geschaefts-bedingungen']">AGB</a></li>
                        <li><a [routerLink]="['/datenschutz']">Datenschutz</a></li>
                        <li><a [routerLink]="['/dsgvo']">DSGVO</a></li>
                        <li><a [routerLink]="['/features']">Features</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
<!--footer end-->
<app-tap-to-top></app-tap-to-top>
